module.exports = __webpack_public_path__ + "static/media/winLarge120_1.18dfbbe3.svg";